import { cloneElement } from "react";
import useMeasure from "react-use-measure";

type Props = {
  children: JSX.Element;
  aspectRatio: number;
  maxHeight?: number;
};

export default function Container({ children, aspectRatio, maxHeight }: Props) {
  const [ref, bounds] = useMeasure();
  const width = bounds.width;
  const aspectHeight = width / aspectRatio;
  const height = maxHeight && maxHeight > aspectHeight ? aspectHeight : maxHeight;

  return <div ref={ref}>{cloneElement(children, { width: width, height: height })}</div>;
}
